import React from 'react';

import {
  Box, FieldGroup, Form, InputField, Modal, Typography, useWindowSize,
} from 'vindi-ds-components';

import { PrMinusSquare, PrPlusSquare } from 'vindi-ds-icons/pr';

import tokens from 'vindi-ds-tokens';

const ModalExport = ({ modalRef }) => {
  const { isMobile } = useWindowSize();
  const [advancedOptionsOpen, setAdvancedOptionsOpen] = React.useState(false);

  const initialValues = {
    export: '',
    format: '',
    charges: [],
    chargesTransaction: [],
  };

  const handleClickClearFilters = ({ setValues }) => () => {
    setValues(initialValues);
  };

  const handleSubmit = () => modalRef.current.close();

  const handleClickAdvancedOptions = () => setAdvancedOptionsOpen(
    (currentAdvancedOptionsOpen) => !currentAdvancedOptionsOpen,
  );

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      id='formExport'
    >
      {(formProps) => (
        <Modal
          ref={modalRef}
          title='Exportar'
          btnPrimaryLabel='Exportar'
          btnPrimaryProps={{ form: 'formExport', type: 'submit' }}
          btnSecondaryLabel='Limpar filtro'
          btnSecondaryClick={handleClickClearFilters(formProps)}
          scrollMode={isMobile ? 'page' : 'modal'}
        >
          <Box mb={3}>
            <Box mb={1}>
              <Typography variant='subtitle2' color='textPrimary'>Exportar</Typography>
            </Box>

            <FieldGroup name='export' radio>
              <InputField label='Apenas página atual' value='firstPage' id='firstPage' />
              <InputField label='Todas as páginas' value='allPages' id='allPages' />
            </FieldGroup>
          </Box>

          <Box mb={4}>
            <Box mb={1}>
              <Typography variant='subtitle2' color='textPrimary'>Formato</Typography>
            </Box>

            <FieldGroup name='format' radio>
              <InputField label='CSV Simples' value='csv' id='csv' />
              <InputField label='Excel' value='excel' id='excel' />
            </FieldGroup>
          </Box>

          <Box
            display='flex'
            alignItems='center'
            color={tokens.color.brand.secondary[500].value}
            mb={4}
            style={{ cursor: 'pointer' }}
            onClick={handleClickAdvancedOptions}
            data-testid='advanced-options'
          >
            <Box display='flex' alignItems='center' mr={1}>
              {advancedOptionsOpen ? (
                <PrMinusSquare color='inherit' />
              ) : (
                <PrPlusSquare color='inherit' />
              )}
            </Box>

            <Typography variant='body2' color='inherit'>Opções avançadas</Typography>
          </Box>

          {advancedOptionsOpen ? (
            <Box>
              <Box mb={2}>
                <Typography variant='subtitle2' color='textPrimary'>Entidades</Typography>
              </Box>

              <Box mb={1}>
                <Typography variant='body1' color='textPrimary' weight='bold'>Cobrança</Typography>
              </Box>

              <Box mb={2}>
                <FieldGroup name='charges' checkbox>
                  <InputField label='Cliente' value='customer' id='customerCustomer' />
                  <InputField label='Método de pagamento' value='paymentMethod' id='paymentMethod' />
                </FieldGroup>
              </Box>

              <Box mb={1}>
                <Typography variant='body1' color='textPrimary' weight='bold'>Transação</Typography>
              </Box>

              <Box mb={2}>
                <FieldGroup name='chargesTransaction' checkbox>
                  <InputField label='Método de pagamento' value='paymentMethod' id='paymentMethodId' />
                  <InputField label='Gateway' value='gateway' id='gateway' />
                  <InputField label='Perfil de pagamento' value='payment' id='paymentMethodId' />
                  <InputField label='Cliente' value='customer' id='customerId' />
                </FieldGroup>
              </Box>

              <Typography variant='body2' color='textPrimary'>Entidades com possibilidade de conter mais de um item serão exportadas em linhas separadas</Typography>
            </Box>
          ) : null}
        </Modal>
      )}
    </Form>
  );
};

export default ModalExport;
